import { analytics } from 'utils/analytics';
import { EKeycardType } from 'reducers/loyalty-registration-modal-reducer';
import { FavoriteDeliveryType } from '../types/checkout-info';
import { SelectionGroupListItem } from '../components/header/components/address-menu/get-selection-group-list';
import { FavoriteAddressDetails, FavoriteAddressState } from '../types/favorite-address';
import { DELIVERY_TYPE_ELEMENT_TEXT, getElementVariant } from './ga-events-utils';

export function sendLoyaltyRegistartionBannerClickEvent() {
  analytics.sendEvent('GA:clickButton', {
    elementType: 'block',
    elementBlock: 'header', // блок, в котором расположен элемент
    elementName: 'headerAccount', // условное обозначение
    elementText: 'Оформить карту лояльности',
  });
}

export const onBasketClickCb = () => {
  analytics.sendEvent('GA:click', {
    name: 'basket', // название элемента
    position: 'header', // блок, в котором расположен элемент
  });
};

export const sendShowLoyaltyRegistrationModalEvent = (mfName: string) => {
  analytics.sendEvent('GA:show', {
    elementType: 'block',
    elementBlock: 'modal',
    elementName: `Выберите свою карту и копите баллы / modal / ${mfName}`,
    elementText: 'Выберите свою карту и копите баллы',
  });
};

export const sendChooseCardEvent = (keycardType: EKeycardType) => {
  const text = keycardType === EKeycardType.HOME ? 'individual_card' : 'profi_card';

  const event = {
    elementType: 'block',
    elementBlock: 'modal',
    elementName: 'Выберите свою карту и копите баллы / modal',
    elementText: text,
  };

  analytics.sendEvent('GA:clickButton', event);
};

export const sendYourCardCompleteEvent = (keycardType: EKeycardType) => {
  const card = keycardType === EKeycardType.HOME ? 'individual_card' : 'profi_card';

  const event = {
    elementType: 'block',
    elementBlock: 'modal',
    elementName: 'Выберите свою карту и копите баллы / modal',
    elementText: `Ваша карта готова / ${card}`,
  };

  analytics.sendEvent('GA:show', event);
};

export const sendGetPromoCheckboxEvent = (value: boolean) => {
  const textValue = value ? 'Да' : 'Нет';

  const event = {
    elementType: 'button',
    elementBlock: 'modal',
    elementName: 'Выберите свою карту и копите баллы / modal',
    elementText: `Хочу получать промокоды и рекламные предложения / ${textValue}`,
  };

  analytics.sendEvent('GA:clickButton', event);
};

const sendAddressDroverClickEvent = (params: { elementText?: string; elementVariant?: string }) => {
  analytics.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'header',
    elementName: 'addressDrover',
    ...params,
  });
};

const sendAddressSnackbarEvent = (eventName: 'GA:show' | 'GA:clickButton', elementText: string) => {
  analytics.sendEvent(eventName, {
    elementType: 'button',
    elementBlock: 'header',
    elementName: 'addressSnackbar',
    elementText,
  });
};

export const sendShowFavoriteAddressHintEvent = (isRegionVariant: boolean) => {
  const textValue = isRegionVariant ? 'Уточните место' : 'Проверьте место';

  sendAddressSnackbarEvent('GA:show', textValue);
};

export const sendChooseOrSubmitFavoriteAddressEvent = (textValue: string) => {
  sendAddressSnackbarEvent('GA:clickButton', textValue);
};

export const sendSubmitAddressEvent = (
  selectionGroupList: SelectionGroupListItem[],
  deliveryType: FavoriteDeliveryType,
  regionName: string,
  address: FavoriteAddressDetails | null,
) => {
  const elementText = selectionGroupList.find(({ id }) => id === deliveryType)?.name;
  const elementVariant = getElementVariant(deliveryType, regionName, address);

  sendAddressDroverClickEvent({
    elementText,
    elementVariant,
  });
};

export const sendApplyNewAddressEvent = () => {
  sendAddressDroverClickEvent({
    elementText: 'Новый адрес',
  });
};

export const sendAddressActionSelectEvent = (
  selectionGroupList: SelectionGroupListItem[],
  deliveryType: FavoriteDeliveryType,
  action: 'edit' | 'delete',
) => {
  const elementText = selectionGroupList.find(({ id }) => id === deliveryType)?.name;
  const elementVariant = action === 'edit' ? 'Редактировать адрес' : 'Удалить адрес';

  sendAddressDroverClickEvent({
    elementText,
    elementVariant,
  });
};

const sendApplyAddressEvent = (elementText: string, elementVariant: string) => {
  const event = {
    elementType: 'block',
    elementBlock: 'header',
    elementName: 'address',
    elementText,
    elementVariant,
  };

  analytics.sendEvent('GA:show', event);
};

export const trackFavoriteAddressChange = (
  cookies: Record<string, string>,
  data: FavoriteAddressState,
  regionName: string,
) => {
  const cookieDeliveryType = cookies.favoriteDeliveryType ?? null;
  const cookiePriorityStoreIds = cookies.priorityStoreIds ?? '';
  const dataPriorityStoreIds = data.priorityStoreIds?.join(',') ?? '';

  const isDeliveryTypeChanged = cookieDeliveryType !== data.deliveryType;
  const isPriorityStoreIdsChanged = cookiePriorityStoreIds !== dataPriorityStoreIds;

  if (!isDeliveryTypeChanged && !isPriorityStoreIdsChanged) {
    return;
  }

  const nextVariant = getElementVariant(data.deliveryType, regionName, data.address);
  const elementText = DELIVERY_TYPE_ELEMENT_TEXT[data.deliveryType];
  sendApplyAddressEvent(elementText, nextVariant);
};
